import React from 'react';
import { Badge } from './ui/badge';
import { LayoutGrid } from 'lucide-react';

export const TABLE_COLORS = {
  table_1: 'bg-sky-600/50 border-sky-400/50 text-sky-100',
  table_2: 'bg-emerald-600/50 border-emerald-400/50 text-emerald-100',
  table_3: 'bg-amber-600/50 border-amber-400/50 text-amber-100',
  table_4: 'bg-rose-600/50 border-rose-400/50 text-rose-100',
  table_ado: 'bg-fuchsia-600/50 border-fuchsia-400/50 text-fuchsia-100',
};

// Displays the tables a member belongs to as colored badges
export const TableBadges = ({ tableIds = [], tables = [], className = '' }) => {
  if (!tableIds.length || !tables.length) return null;
  const names = Object.fromEntries(tables.map((t) => [t.table_id, t.name]));
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="table-badges">
      {tableIds.map((id) => (
        <Badge key={id} data-testid={`table-badge-${id}`} className={`${TABLE_COLORS[id] || 'bg-purple-600/50 border-purple-400/50 text-purple-100'} text-xs`}>
          <LayoutGrid className="h-3 w-3 mr-1" />
          {names[id] || id}
        </Badge>
      ))}
    </div>
  );
};
